var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAdvisorCollapseAll = function SvgIconAdvisorCollapseAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.964 3.279 3.334 3.333L11.63 3.28",
    stroke: "#747474",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "top",
    "data-no-fill": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.964 13.946 3.334-3.334 3.333 3.334",
    stroke: "#747474",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "bottom",
    "data-no-fill": "true"
  })));
};
export { SvgIconAdvisorCollapseAll as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTcgMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aAogICAgICAgIGQ9Ik00Ljk2NDM2IDMuMjc4ODFMOC4yOTc2OSA2LjYxMjE0TDExLjYzMSAzLjI3ODgxIgogICAgICAgIHN0cm9rZT0iIzc0NzQ3NCIKICAgICAgICBzdHJva2Utd2lkdGg9IjIiCiAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgICAgICAgZGF0YS1uYW1lPSJ0b3AiCiAgICAgICAgZGF0YS1uby1maWxsPSJ0cnVlIgogICAgLz4KICAgIDxwYXRoCiAgICAgICAgZD0iTTQuOTY0MzYgMTMuOTQ1Nkw4LjI5NzY5IDEwLjYxMjNMMTEuNjMxIDEzLjk0NTYiCiAgICAgICAgc3Ryb2tlPSIjNzQ3NDc0IgogICAgICAgIHN0cm9rZS13aWR0aD0iMiIKICAgICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIKICAgICAgICBkYXRhLW5hbWU9ImJvdHRvbSIKICAgICAgICBkYXRhLW5vLWZpbGw9InRydWUiCiAgICAvPgo8L3N2Zz4K";